import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

const PageProductUpdates: Definition = {
  contentType: 'PageProductUpdates',
  fields: [
    {
      id: 'subtitle',
      name: 'Title Subheader',
      type: 'Symbol'
    },
    {
      id: 'announcement',
      name: 'Announcement',
      type: 'BlockHighlight'
    },
    {
      id: 'productFilterLabel',
      name: 'Product Filter Label',
      type: 'Symbol'
    },
    {
      id: 'businessTypeFilterLabel',
      name: 'Business Type Filter Label',
      type: 'Symbol'
    },
    {
      id: 'dateFilterLabel',
      name: 'Date Filter Label',
      type: 'Symbol'
    },
    {
      id: 'resultsTitle',
      name: 'Results Title (for current month)',
      type: 'Symbol'
    },
    // @TODO Validate if a label for mobile is needed
    {
      id: 'scrollToNewsletterTitle',
      name: 'Scroll to newsletter Title',
      type: 'Symbol'
    },
    {
      id: 'scrollToNewsletterDescription',
      name: 'Scroll to newsletter Description',
      type: 'Symbol'
    },
    {
      id: 'olderPosts',
      name: 'Older posts',
      type: 'Symbol'
    },
    {
      id: 'newerPosts',
      name: 'Newer posts',
      type: 'Symbol'
    },
    {
      id: 'noResults',
      name: 'No Results',
      type: 'Symbol'
    },
    {
      id: 'form',
      name: 'Newsletter Form',
      type: 'BlockForm'
    }
  ]
}

const PageProductUpdatesDetail: Definition = {
  contentType: 'PageProductUpdatesDetail',
  fields: [
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol'
    },
    {
      id: 'date',
      name: 'Date',
      type: 'Date',
      required: true
    },
    {
      id: 'products',
      name: 'Product Tags',
      type: 'Array',
      subType: 'ProductUpdatesProduct'
    },
    {
      id: 'businessType',
      name: 'Business Type',
      type: 'Array',
      subType: 'GlobalDataBusinessType',
      validations: [{ size: { min: 0, max: 5 } }]
    },
    {
      id: 'countryAvailability',
      name: 'Country Availability',
      type: 'Array',
      subType: 'GlobalDataCountry',
      validations: [{ size: { min: 0, max: 50 } }]
    },
    {
      id: 'image',
      name: 'Image',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns12_169, lazy: true }
    },
    {
      id: 'content',
      name: 'Content',
      type: 'RichText'
    },
    {
      id: 'integrationTypeDescription',
      name: 'Integration Type Description (modal)',
      type: 'Symbol'
    },
    {
      id: 'terminalRequirementsDescription',
      name: 'Terminal Requirements Description (modal)',
      type: 'Symbol'
    },
    {
      id: 'otherTitle',
      name: 'Other Title (modal)',
      type: 'Symbol'
    },
    {
      id: 'otherDescription',
      name: 'Other Description (modal)',
      type: 'Symbol'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'Array',
      subType: 'BlockCallToAction',
      validations: [{ size: { min: 0, max: 2 } }]
    }
  ]
}

export default {
  PageProductUpdates,
  PageProductUpdatesDetail
}
